import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-increment-number-input',
  templateUrl: './increment-number-input.component.html',
  styleUrls: ['./increment-number-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IncrementNumberInputComponent),
      multi: true
    }
  ]
})
export class IncrementNumberInputComponent implements OnInit, ControlValueAccessor {
  @Input() number: number = 0;
  @Input() min: number = 0;
  @Input() max: number = Infinity;
  @Output() numberChange = new EventEmitter<number>();

  @Input() isDisabled: boolean = false;

  private onChange: (value: number) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {}

  ngOnInit() {}

  increment() {
    if (this.number < this.max) {
      this.number++;
      this.onChange(this.number);
      this.numberChange.emit(this.number);
    }
  }

  decrement() {
    if (this.number > this.min) {
      this.number--;
      this.onChange(this.number);
      this.numberChange.emit(this.number);
    }
  }

  onInput(event: any) {
    let value = event.target.value;
    if (value < this.min) {
      this.number = this.min;
    } else if (value > this.max) {
      this.number = this.max;
    } else {
      this.number = value;
    }
    this.onChange(this.number);
    this.numberChange.emit(this.number);
  }

  writeValue(value: number): void {
    this.number = value;
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
